import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Modal, Table, Space } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import AddVille from "./AddVille";
import { toast } from "react-toastify";
import ActionDropdown from "../../production/components/ActionDropdown";

const Villes = () => {
  const [villes, setVilles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedVille, setSelectedVille] = useState(null);

  useEffect(() => {
    fetchVilles();
  }, []);

  const fetchVilles = () => {
    axios
      .get(`${API_URL}/api/parametre/type/VILLE`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      })
      .then((res) => {
        const sorted = res.data.sort((a, b) => b.parametreId - a.parametreId);
        setVilles(sorted);
      })
      .catch((err) => console.error("Erreur lors de la récupération :", err));
  };

  const handleShow = (edit = false, ville = null) => {
    setShowModal(true);
    setEditMode(edit);
    setSelectedVille(ville);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedVille(null);
  };

  const handleAdd = (newVille) => {
    setVilles((prev) => [newVille, ...prev]);
  };

  const handleUpdate = (updatedVille) => {
    setVilles((prev) =>
      prev.map((ville) =>
        ville.parametreId === updatedVille.parametreId ? updatedVille : ville
      )
    );
  };

  const handleDeleteVille = (villeId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette ville ?",
      content: "Cette action est irréversible",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () => {
        axios
          .delete(`${API_URL}/api/parametre/${villeId}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          })
          .then(() => {
            setVilles((prev) => prev.filter((v) => v.parametreId !== villeId));
            toast.success("Ville supprimée avec succès.");
          })
          .catch((err) => {
            console.error("Erreur suppression ville:", err);
            toast.error("Erreur lors de la suppression de la ville.");
          });
      },
    });
  };

  const columns = [
    {
      title: "Nom",
      dataIndex: "libelleParametre",
      key: "libelleParametre",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <i className="bx bx-edit-alt" />,
              onClick: () => handleShow(true, record),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <i className="bx bx-trash" />,
              danger: true,
              onClick: () => handleDeleteVille(record.parametreId),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="AUTRES_PARAMETRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow()}
              >
                Ajouter une nouvelle ville
              </Button>
              <div className="card">
                <h5 className="card-header">Paramétrage de villes</h5>
                <Table
                  columns={columns}
                  dataSource={villes}
                  rowKey="parametreId"
                  pagination={{ pageSize: 10, showSizeChanger: true }}
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <AddVille
        show={showModal}
        handleClose={handleClose}
        editMode={editMode}
        selectedVille={selectedVille}
        villes={villes}
        onAdd={handleAdd}
        onUpdate={handleUpdate}
      />
    </div>
  );
};

export default Villes;
